/* eslint-disable react/jsx-props-no-spreading */

import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as fas from '@fortawesome/free-solid-svg-icons';
import * as fab from '@fortawesome/free-brands-svg-icons';
import * as far from '@fortawesome/free-regular-svg-icons';

const modules = { ...fas, ...fab, ...far };
const moduleKeys = Object.keys(modules);

export default function Icon({ logo, ...props }) {
  let i = modules[logo || ''];

  return <FontAwesomeIcon icon={i} {...props} />;
}

Icon.propTypes = {
  logo: PropTypes.oneOf(moduleKeys).isRequired
};
